module.exports = __webpack_public_path__ + "static/images/backPack_enter.9ee9896.png";